import React from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'helpers/LazyImage';
import {trustpilot} from 'ferries/Home/components/Testimonials/helper';
import trustpilotIcon from 'assets/images/payment/servicePackage/trustpilot.svg';
import googleIcon from 'assets/images/email-client/google.svg';

const TestimonialLogo = ({source}) => {
  const reviewSource = source === trustpilot ? trustpilotIcon : googleIcon;

  return (
    <div className="d-flex align-items-center justify-content-start mb-3">
      <LazyImage
        src={reviewSource}
        width='100%'
        height='32px'
        title={source}
        alt={source}
      />
    </div>
  );
};

TestimonialLogo.propTypes = {
  source: PropTypes.string.isRequired
};

export default TestimonialLogo;
